import React, { useEffect, useState } from "react";
import { Modal } from "../../CommonUIComponents/Modal/Modal";
import {
  ApplyBtn,
  emissionFilterTooltip,
  filters,
  reset,
  dropdowns,
  DataSelection,
} from "../../../util/constants";
import { Tooltip } from "../../CommonUIComponents/Tooltip/Tooltip";
import { EmissionIcon } from "../../../icons";
import "../Emissions.scss";
import { Select } from "../../CommonUIComponents/Select/Select";
import { Button } from "../..";
import { useSelector, useDispatch } from "react-redux";
import {
  saveEmissionFiltersReduce,
  getReduceDefautViewData,
} from "../../../store/services/project.service";
import {
  setReduceDefautViewData,
  setselectedUIAllFilters,
  setAppliedFiltersPayload,
  setSimulateFlag,
  setGraphSimulateFlag,
  setTableFiltersApplied,
  setDropdownMetadata,
  setUnitValidationFlag,
  setHasDataSelectionApplied,
  setHierarchialData,
} from "../../../store/slices/projectSlice";
import { LoadingIndicatorEmbed } from "../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { getReplaceHierarchyData } from "../../../store/services/engagement.service";

function ModalBody({ onApply, onReset }) {
  const dispatch = useDispatch();
  //Fetching state variables
  const initialDropdowns = useSelector(
    (state) => state.project.hierarchialData
  );
  const selectedUIAllFilters = useSelector(
    (state) => state.project.selectedUIAllFilters
  );
  const hierarchialData = useSelector((state) => state.project.hierarchialData);
  
  const convertEmptyToBlank = (filters) => {
    if (!filters || Array.isArray(filters) || typeof filters !== 'object') return filters;
    const converted = { ...filters };
    Object.keys(converted).forEach(key => {
      if (Array.isArray(converted[key])) {
        converted[key] = converted[key].map(value => value === "" ? "(blank)" : value);
      }
    });
    return converted;
  };
  
  const [selectedUIfilters, setSelectedUIAllFilters] =
    useState(() => convertEmptyToBlank(selectedUIAllFilters));
  const [dropdownOptions, setDropdownOptions] = useState([...initialDropdowns]);
  const [frozenDataset, setFrozenDataset] = useState([...initialDropdowns]);
  const project = useSelector((state) => state.project.project);
  const engagement = useSelector((state) => state.engagement.engagement);
  const user = useSelector((state) => state.user.user);
  const [showLoader, setLoader] = useState(false);
  const [modalFiltersApplied, setModalFiltersApplied] = useState(false);
  const [errorMsg, setErrorMsg] = useState([]);
  const [validScopes, setValidScopes] = useState([]);
  const keys = [{ field: 'scope', headerName: 'Scope' }, { field: 'category_level1', headerName: 'Category 1' }, { field: 'category_level2', headerName: 'Category 2' }, { field: 'category_level3', headerName: 'Category 3' }, { field: 'region_level1', headerName: 'Region Level1' }, { field: 'region_level2', headerName: 'Region Level2' }, { field: 'region_level3', headerName: 'Region Level3' }, { field: 'entity_level1', headerName: 'Entity Level1' }, { field: 'entity_level2', headerName: 'Entity Level2' }, { field: 'entity_level3', headerName: 'Entity Level3' }, { field: 'entity_level4', headerName: 'Entity Level4' }, { field: 'custom_specification1', headerName: 'Custom 1' }, { field: 'custom_specification2', headerName: 'Custom 2' }, { field: 'custom_specification3', headerName: 'Custom 3' }];
  const [errorInSelection, setErrorInSelection] = useState(false);
  const [isDropdownChanging, setDropdownChanging] = useState(false);

  // Locking the initial Dataset based on the Header Filter selection
  useEffect(() => {
    if (project?.projectId) {
      setInitialDropdowns();
    }
  }, [project?.projectId]);

  useEffect(() => {
    keys?.map(key => {
      if(Array.isArray(selectedUIfilters[key?.field]) && selectedUIfilters[key?.field]?.length > 0 && (!selectedUIfilters?.latest_filter || selectedUIfilters?.highestLevelFilter)){
        dispatch(setselectedUIAllFilters({selectedUIAllFilters: {}}));
        setSelectedUIAllFilters([]);
      }
    })   
    },[]);

  //Enabling/disabling Apply button
  useEffect(() => {    
    const hasValidEntries = Object.entries(selectedUIfilters).some(([key, value]) => {
      return Array.isArray(value) && value.length > 0; // Check if the value is an array and has elements
    });
    if (!hasValidEntries) {
      setModalFiltersApplied(false);
    } else {
      setModalFiltersApplied(true);
    }
  }, [selectedUIfilters]);

  useEffect(() => {
    setDropdownOptions(initialDropdowns);
    setFrozenDataset(initialDropdowns);
  }, [initialDropdowns]);

  //Populating initial dropdown values
  const setInitialDropdowns = async () => {
    if (project.projectType === 2) {
      let request = {
        engagementCode: engagement.engagementCode,
        projectID: project.projectId,
      };
      const data = await getReplaceHierarchyData({ request });
      dispatch(setHierarchialData({ hierarchialData: data }));
    }
    setFrozenDataset(initialDropdowns);
  };

  //Disabling dropdowns based on header filters selection
  const disableDropdowns = (label) => {
    switch (label) {
      case "Category 1":
      case "category_level1":
        if (
          selectedUIfilters.scope?.length === 0 ||
          !selectedUIfilters.scope ||
          selectedUIfilters.category_level1?.length === 0 ||
          !selectedUIfilters.category_level1
        ) {
          return true;
        }
        break;
      case "Category 2":
      case "category_level2":
        if (
          selectedUIfilters.category_level2?.length === 0 ||
          !selectedUIfilters.category_level2
        ) {
          return true;
        }
        break;
      case "Category 3":
      case "category_level3":
        if (
          selectedUIfilters.category_level3?.length === 0 ||
          !selectedUIfilters.category_level3
        ) {
          return true;
        }
        break;
      case "Region level 1":
      case "region_level1":
        if (selectedUIfilters.scope?.length === 0 || !selectedUIfilters.scope
          || selectedUIfilters.region_level1?.length === 0 ||
          !selectedUIfilters.region_level1
        ) {
          return true;
        }
        break;
      case "Region level 2":
      case "region_level2":
        if (
          selectedUIfilters.region_level2?.length === 0 ||
          !selectedUIfilters.region_level2
        ) {
          return true;
        }
        break;
      case "Region level 3":
      case "region_level3":
        if (
          selectedUIfilters.region_level3?.length === 0 ||
          !selectedUIfilters.region_level3
        ) {
          return true;
        }
        break;
      case "Entity level 1":
        if (selectedUIfilters.scope?.length === 0 || !selectedUIfilters.scope
          || selectedUIfilters.entity_level1?.length === 0 ||
          !selectedUIfilters.entity_level1
        ) {
          return true;
        }
        break;
      case "Entity level 2":
      case "entity_level2":
        if (
          selectedUIfilters.entity_level2?.length === 0 ||
          !selectedUIfilters.entity_level2
        ) {
          return true;
        }
        break;
      case "Entity level 3":
      case "entity_level3":
        if (
          selectedUIfilters.entity_level3?.length === 0 ||
          !selectedUIfilters.entity_level3
        ) {
          return true;
        }
        break;
      case "Entity level 4":
      case "entity_level4":
        if (
          selectedUIfilters.entity_level4?.length === 0 ||
          !selectedUIfilters.entity_level4
        ) {
          return true;
        }
        break;
      case "Custom level 1":
      case "custom_specification1":
        if (selectedUIfilters.scope?.length === 0 || !selectedUIfilters.scope
          || selectedUIfilters.custom_specification1?.length === 0 ||
          !selectedUIfilters.custom_specification1
        ) {
          return true;
        }
        break;
      case "Custom level 2":
      case "custom_specification2":
        if (
          selectedUIfilters.custom_specification2?.length === 0 ||
          !selectedUIfilters.custom_specification2
        ) {
          return true;
        }
        break;
      case "Custom level 3":
      case "custom_specification3":
        if (
          selectedUIfilters.custom_specification3?.length === 0 ||
          !selectedUIfilters.custom_specification3
        ) {
          return true;
        }
        break;
      default:
        return false;
    }
  };

  // Handling dropdown change

  const handleDropdownChange = async (event, fieldId) => {
    setDropdownChanging(true);
    switch (fieldId) {
      case "scope":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          scope: event,
          // category_level1: [],
          // category_level2: [],
          // category_level3: [],
          // region_level1: [],
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "category_level1":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          category_level1: event,
          // category_level2: [],
          // category_level3: [],
          // region_level1: [],
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "category_level2":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          category_level2: event,
          // category_level3: [],
          // region_level1: [],
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "category_level3":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          category_level3: event,
          // region_level1: [],
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "region_level1":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          region_level1: event,
          // region_level2: [],
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "region_level2":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          region_level2: event,
          // region_level3: [],
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "region_level3":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          region_level3: event,
          // entity_level1: [],
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "entity_level1":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          entity_level1: event,
          // entity_level2: [],
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "entity_level2":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          entity_level2: event,
          // entity_level3: [],
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "entity_level3":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          entity_level3: event,
          // entity_level4: [],
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "entity_level4":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          entity_level4: event,
          // custom_specification1: [],
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "custom_specification1":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          custom_specification1: event,
          // custom_specification2: [],
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "custom_specification2":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          custom_specification2: event,
          // custom_specification3: [],
          latest_filter: fieldId,
        });
        break;
      case "custom_specification3":
        setSelectedUIAllFilters({
          ...selectedUIfilters,
          custom_specification3: event,
          latest_filter: fieldId,
        });
        break;
      default:
        break;
    }
    setModalFiltersApplied(true);
  };

  useEffect(() => {
    handleValidationForSelections();
  }, [selectedUIfilters]);

  const handleValidationForSelections = () => {
    const possibleCombinations = hierarchialData; // API data
    const selectedCombinations = selectedUIfilters; // User's selected filters
    let errors = [];
    let err = [];

    // Check if the selected scope has valid combinations
    if (selectedCombinations.scope && selectedCombinations.scope.length > 0) {
      // Filter valid entries based on selected scopes
      const initialValidScopes = possibleCombinations.filter(item =>
        selectedCombinations.scope.includes(item.scope)
      );
      let recentlySelectedFilter = selectedCombinations?.latest_filter;
      let recentlySelectedFilterLabel;
      keys?.map(data => {
        if (data?.field === recentlySelectedFilter) {
          recentlySelectedFilterLabel = data?.headerName;
        }
      })
      if (!recentlySelectedFilter) {
        keys?.map(data => {
          if (data?.headerName === selectedCombinations?.highestLevelFilter) {
            recentlySelectedFilter = data?.field;
          }
        })
      }
      const allOptions = possibleCombinations.map(item => item[recentlySelectedFilter]); // Extract all options based on the filter
      const uniqueAllOptions = [...new Set(allOptions)];
      const selectedCategories = selectedCombinations[recentlySelectedFilter];


      // Validate
      if (recentlySelectedFilter !== 'scope') {
        const validScopesToUse = validScopes?.length > 0 ? validScopes : initialValidScopes;
        const allSelected = uniqueAllOptions?.length === selectedCategories?.length &&
          uniqueAllOptions?.every(option => selectedCategories?.includes(option));
        selectedCombinations[recentlySelectedFilter]?.forEach(category => {
          const validCategories = validScopesToUse?.filter(item => item[recentlySelectedFilter] === category);
          if (validCategories?.length !== 0 && !allSelected) {
            setValidScopes(validCategories);
          }
          validCategories?.map(item => {
            if (!item[recentlySelectedFilter]?.includes(selectedCombinations[recentlySelectedFilter])) {
              err.push(true);
            }
          })
          // if((err.length !== 0 || validCategories?.length === 0) && errors?.length === 0 && !allSelected){
          //   errors.push(`Invalid selection for ${recentlySelectedFilterLabel}. It is not available for the selections.`);
          //   keys?.forEach(key => {
          //     if(selectedCombinations[key]?.length === 0 || selectedCombinations[key] == undefined){
          //       disableDropdowns(key);
          //       setErrorInSelection(true);
          //     }
          //   })
          // }
        });
      }
    }
    // Set error messages if any
    if (errors.length > 0) {
      setErrorMsg(errors);
    } else {
      setErrorMsg([]); // Clear errors if valid
      setErrorInSelection(false);
    }
  };

  // Populating the dropdown values
     const getDropdownValues = (fieldId) => {
        let dataset = [...dropdownOptions];
       const allArraysHaveValues = keys.every(key => {
        const field = key?.field;
        return selectedUIfilters[field] ? Array.isArray(selectedUIfilters[field]) && selectedUIfilters[field].length > 0 : false;
    });

        // Iterate through all keys to filter the dataset based on selected values
        keys.forEach(key => {
            if (key?.field !== fieldId) { // Skip the current fieldId
                const selectedValues = selectedUIfilters[key?.field] || [];
                const datasett = dataset?.filter(element => selectedValues?.length > 0 ? (selectedValues?.includes(element[key?.field]) || selectedValues.includes('(blank)')) : []);
                if (datasett?.length !== 0) {
                    dataset = datasett;
                }
            }
        });

        if(allArraysHaveValues && !isDropdownChanging){
          keys?.forEach(key => {
            const data = dataset?.filter(elem => {
              const elemValue = elem[key?.field];
              const selectedValues = selectedUIfilters[key?.field] || [];
              return selectedValues?.includes(elemValue) || (elemValue === "" && selectedValues?.includes("(blank)"));
            }) || [];
              if(data?.length !== 0){
              dataset = data;
              }      
          })      
        }

        // Get unique values for the current dropdown and sort them
        let array = [...new Set(dataset.map(element => element[fieldId]))];
        array = array.map(value => value === "" ? "(blank)" : value);
        array = array.sort();
        return array;      
    };

  //Resetting the dropdowns
  const resetDropdowns = async () => {
    setDropdownChanging(false);
    setDropdownOptions(frozenDataset);
    setSelectedUIAllFilters({});
    dispatch(setselectedUIAllFilters({ selectedUIAllFilters: {} }));
    dispatch(setAppliedFiltersPayload({ filtersPayload: {} }));
    dispatch(setUnitValidationFlag({ flag: {} }));
    dispatch(setHasDataSelectionApplied({ hasApplied: false }));
    dispatch(setTableFiltersApplied({ isApplied: false }));
    setModalFiltersApplied(false);
    if (onReset) {
      onReset();
    }
  };

  //Applying the filters
  const applyFilters = async (selectedUIfilters, action) => {
    setDropdownChanging(false);
    setLoader(true);
    const updatedFilters = { ...selectedUIfilters }; 
    const filters = {
      scope: action === "Reset" ? ["All"] : selectedUIfilters["scope"],
      category_level1:
        selectedUIfilters["category_level1"]?.length > 0
          ? selectedUIfilters["category_level1"]
          : ["All"],
      category_level2:
        selectedUIfilters["category_level2"]?.length > 0
          ? selectedUIfilters["category_level2"]
          : ["All"],
      category_level3:
        selectedUIfilters["category_level3"]?.length > 0
          ? selectedUIfilters["category_level3"]
          : ["All"],
      region_level1:
        selectedUIfilters["region_level1"]?.length > 0
          ? selectedUIfilters["region_level1"]
          : ["All"],
      region_level2:
        selectedUIfilters["region_level2"]?.length > 0
          ? selectedUIfilters["region_level2"]
          : ["All"],
      region_level3:
        selectedUIfilters["region_level3"]?.length > 0
          ? selectedUIfilters["region_level3"]
          : ["All"],
      entity_level1:
        selectedUIfilters["entity_level1"]?.length > 0
          ? selectedUIfilters["entity_level1"]
          : ["All"],
      entity_level2:
        selectedUIfilters["entity_level2"]?.length > 0
          ? selectedUIfilters["entity_level2"]
          : ["All"],
      entity_level3:
        selectedUIfilters["entity_level3"]?.length > 0
          ? selectedUIfilters["entity_level3"]
          : ["All"],
      entity_level4:
        selectedUIfilters["entity_level4"]?.length > 0
          ? selectedUIfilters["entity_level4"]
          : ["All"],
      custom_specification1: selectedUIfilters["custom_specification1"]?.length > 0
                ? selectedUIfilters["custom_specification1"].map(value => value === "(blank)" ? "" : value)
                : ["All"],
      custom_specification2: selectedUIfilters["custom_specification2"]?.length > 0
                ? selectedUIfilters["custom_specification2"].map(value => value === "(blank)" ? "" : value)
                : ["All"],
      custom_specification3: selectedUIfilters["custom_specification3"]?.length > 0
                ? selectedUIfilters["custom_specification3"].map(value => value === "(blank)" ? "" : value)
                : ["All"],
    };
    const scope = ["All"];   
    if(!filters?.scope || filters?.scope == undefined || filters?.scope?.length == 0){
      filters.scope = scope;
    }
    const payload = await constructPayload(filters);
    const apiResponse = await saveEmissionFiltersReduce({ payload });
    const emessionFilterCounter = apiResponse?.[0]?.counter;
    const allFields = keys
            ?.map(k => k.field);
        
        const cleanedPayload = Object.fromEntries(
            Object.entries(selectedUIfilters)?.filter(
                ([_, value]) => !(Array.isArray(value) && value?.length === 0)
            )
        );

        const presentFields = Object.keys(cleanedPayload);
        const missingFields = allFields?.filter(
            field => !presentFields?.includes(field)
        );
        // const finalPayload = { ...selectedUIfilters };
        missingFields?.forEach(fieldId => {
            const value = updatedFilters[fieldId];
            if (!Array.isArray(value) || value?.length === 0) {
                updatedFilters[fieldId] = getDropdownValues(fieldId) ?? [];
                 if (!updatedFilters[fieldId]) {
            updatedFilters[fieldId] = [];
        }

        // Assuming finalPayload[fieldId] is a single value or an array of values
        const valuesToAdd = Array.isArray(updatedFilters[fieldId]) ? updatedFilters[fieldId] : [updatedFilters[fieldId]];

        // Use a Set to avoid duplicates
        const uniqueValues = new Set(updatedFilters[fieldId]);

        valuesToAdd.forEach(value => {
            uniqueValues.add(value); // Add each value to the Set
        });

        // Convert the Set back to an array and assign it to selectedUIfilters[fieldId]
        updatedFilters[fieldId] = Array.from(uniqueValues);
        const customValues = ['custom_specification1', 'custom_specification2', 'custom_specification3'];
        customValues.forEach(fieldId => {
          if (updatedFilters[fieldId]) {
              updatedFilters[fieldId] = Array.from(updatedFilters[fieldId]).map(value => value === "(blank)" ? "" : value);
          }          
        });
         setSelectedUIAllFilters(updatedFilters);
            }            
        });

    dispatch(
      setUnitValidationFlag({
        flag: {
          isDuplicate_AD: apiResponse?.[0]?.isDuplicate_AD,
          isDuplicate_EF: apiResponse?.[0]?.isDuplicate_EF,
          eF_VALUE_COUNT: apiResponse?.[0]?.eF_VALUE_COUNT,
        },
      })
    );
    dispatch(setHasDataSelectionApplied({ hasApplied: true }));
    const selectedFilters = ["scope"];
    selectedUIfilters["category_level1"]?.length > 0 &&
      selectedFilters.push("category_level1");
    selectedUIfilters["category_level2"]?.length > 0 &&
      selectedFilters.push("category_level2");
    selectedUIfilters["category_level3"]?.length > 0 &&
      selectedFilters.push("category_level3");
    selectedUIfilters["region_level1"]?.length > 0 &&
      selectedFilters.push("region_level1");
    selectedUIfilters["region_level2"]?.length > 0 &&
      selectedFilters.push("region_level2");
    selectedUIfilters["region_level3"]?.length > 0 &&
      selectedFilters.push("region_level3");
    selectedUIfilters["entity_level1"]?.length > 0 &&
      selectedFilters.push("entity_level1");
    selectedUIfilters["entity_level2"]?.length > 0 &&
      selectedFilters.push("entity_level2");
    selectedUIfilters["entity_level3"]?.length > 0 &&
      selectedFilters.push("entity_level3");
    selectedUIfilters["entity_level4"]?.length > 0 &&
      selectedFilters.push("entity_level4");
    selectedUIfilters["custom_specification1"]?.length > 0 &&
      selectedFilters.push("custom_specification1");
    selectedUIfilters["custom_specification2"]?.length > 0 &&
      selectedFilters.push("custom_specification2");
    selectedUIfilters["custom_specification3"]?.length > 0 &&
      selectedFilters.push("custom_specification3");
    const request = {
      engagementCode: engagement.engagementCode,
      projectID: project.projectId,
      columnNames: selectedFilters,
      numberOfYears: engagement.foreCastEndYear - engagement.mostRecentYear,
      viewType: "M3-ApplyFilter",
      modifiedBy: user.username,
      counter: emessionFilterCounter,
    };
    dispatch(setAppliedFiltersPayload({ filtersPayload: request }));
    const data = await getReduceDefautViewData({ request });
    dispatch(setReduceDefautViewData({ defaultViewData: data }));
    dispatch(setSimulateFlag({ isSimulate: false }));
    dispatch(setGraphSimulateFlag({ isGraphSimulate: false }));
    dispatch(
      setselectedUIAllFilters({ selectedUIAllFilters: updatedFilters })
    );
    action === "Apply" && dispatch(setTableFiltersApplied({ isApplied: true }));
    setLoader(false);
    setModalFiltersApplied(false);
    onApply();
  };

  // Payload consstruction for applying filters
  const constructPayload = async (filters) => {
    let dropDownMetaData = [];
    const selectedScope = (filters?.scope || []).map((x) => {
    return { columnType: "Scope", columnValue: x };
    });
    const selectedCatLevel1 = filters?.category_level1?.map((x) => {
      return { columnType: "Category_level1", columnValue: x };
    });
    const selectedCatLevel2 = filters?.category_level2?.map((x) => {
      return { columnType: "Category_level2", columnValue: x };
    });
    const selectedCatLevel3 = filters?.category_level3?.map((x) => {
      return { columnType: "Category_level3", columnValue: x };
    });
    //Geo Data
    const selectedRegionLevel1 = filters?.region_level1?.map((x) => {
      return { columnType: "Region_level1", columnValue: x };
    });
    const selectedRegionLevel2 = filters?.region_level2?.map((x) => {
      return { columnType: "Region_level2", columnValue: x };
    });
    const selectedRegionLevel3 = filters?.region_level3?.map((x) => {
      return { columnType: "Region_level3", columnValue: x };
    });

    //Org Data
    const selectedEntityLevel1 = filters?.entity_level1?.map((x) => {
      return { columnType: "Entity_level1", columnValue: x };
    });
    const selectedEntityLevel2 = filters?.entity_level2?.map((x) => {
      return { columnType: "Entity_level2", columnValue: x };
    });
    const selectedEntityLevel3 = filters?.entity_level3?.map((x) => {
      return { columnType: "Entity_level3", columnValue: x };
    });
    const selectedEntityLevel4 = filters?.entity_level4?.map((x) => {
      return { columnType: "Entity_level4", columnValue: x };
    });
    const selectedCustom1 = filters?.custom_specification1?.map((x) => {
      return { columnType: "Custom_specification1", columnValue: x };
    });
    const selectedCustom2 = filters?.custom_specification2?.map((x) => {
      return { columnType: "Custom_specification2", columnValue: x };
    });
    const selectedCustom3 = filters?.custom_specification3?.map((x) => {
      return { columnType: "Custom_specification3", columnValue: x };
    });

    dropDownMetaData = [
      ...selectedScope,
      ...selectedCatLevel1,
      ...selectedCatLevel2,
      ...selectedCatLevel3,
      ...selectedRegionLevel1,
      ...selectedRegionLevel2,
      ...selectedRegionLevel3,
      ...selectedEntityLevel1,
      ...selectedEntityLevel2,
      ...selectedEntityLevel3,
      ...selectedEntityLevel4,
      ...selectedCustom1,
      ...selectedCustom2,
      ...selectedCustom3,
    ];
    dispatch(setDropdownMetadata({ data: dropDownMetaData }));
    const payload = {
      engagementId: engagement.id,
      engagementCode: engagement.engagementCode,
      name: project.projectName,
      moduleName: "M3-ApplyFilter",
      CreatedBy: user.username,
      modifiedby: user.username,
      dropDownMetaData: dropDownMetaData,
      projectId: project.projectId,
    };
    return payload;
  };

  return (
    <div className="emission-filter-modal">
      <div className="emission-filter-modal-content">
        {dropdowns.map((element) => {
          return (
            <div className="emission-filter-modal-content-main">
              <span className="emission-filter-modal-label" key={element.Name}>
                {element.Name}
              </span>
              <div className="emission-filter-modal-content-dropdowns">
                {element.dropdownList.map((dropdown) => {
                  return (
                    <div>
                      <span className="emission-filter-modal-content-dropdowns-label">
                        {dropdown.label}
                      </span>
                      <Select
                        options={getDropdownValues(dropdown.fieldId)}
                        disabled={errorInSelection ? disableDropdowns(dropdown.label) : false}
                        value={
                          selectedUIfilters[dropdown.fieldId]
                            ? selectedUIfilters[dropdown.fieldId]
                            : []
                        }
                        onChange={(event) => {
                          handleDropdownChange(
                            event,
                            dropdown.fieldId,
                            dropdown.id
                          );
                        }}
                        multiple={true}
                        showSelectAllButton={true}
                      ></Select>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div className="emission-filter-modal-footer">
        {errorMsg && (
          <div style={{ color: 'red', marginTop: '10px' }}>
            {errorMsg}
          </div>
        )}
        <Button
          variant="secondary"
          onClick={() => {
            resetDropdowns();
          }}
          disabled={!modalFiltersApplied}
        >
          {reset}
        </Button>
        <LoadingIndicatorEmbed show={showLoader}>
          <Button
            variant="primary"
            onClick={() => applyFilters(selectedUIfilters, "Apply")}
            disabled={!modalFiltersApplied}
          >
            {ApplyBtn}
          </Button>
        </LoadingIndicatorEmbed>
      </div>
    </div>
  );
}

export function EmissionFilterModal({ isFilterOpen, onClose, onApply, onReset }) {
  const handleApply = () => {
    if (onApply) {
      onApply();
    }
    onClose();
  };
  return (
    <Modal
      show={isFilterOpen}
      onClose={onClose}
      header={
        <div className="emission-filter-modal-header">
          <span>{DataSelection}<span className="required-star">*</span></span>
          <Tooltip
            trigger={<EmissionIcon />}
            variant="ghost"
            tooltipText={emissionFilterTooltip}
          ></Tooltip>
        </div>
      }
      body={<ModalBody onApply={handleApply} onReset={onReset}></ModalBody>}
      className={"emission-gmp-modal"}
    ></Modal>
  );
}
